import { render, staticRenderFns } from "./SwipeActions.vue?vue&type=template&id=7544207b&scoped=true&"
import script from "./SwipeActions.vue?vue&type=script&lang=js&"
export * from "./SwipeActions.vue?vue&type=script&lang=js&"
import style0 from "./SwipeActions.vue?vue&type=style&index=0&id=7544207b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7544207b",
  null
  
)

export default component.exports